/** THE PAIRS' LOGOS (2026-10-28, owner: "add all pair logo possible in annotation chart"): one small
 *  image per coin in `public/logos/<TICKER>.<ext>`, served by the console itself (same origin, CSP
 *  `img-src 'self'`). Generated from CoinGecko for every base the venues list (Bybit, Binance and
 *  MEXC spot and perpetuals): 1,690 of their 1,925 bases on 2026-10-28; a ticker shared by several
 *  coins takes the one with the larger market value. Keyed by ticker, the file's extension. */
export const COIN_LOGOS: Record<string, string> = {
  "0G": "png",
  "1INCH": "jpg",
  "1MBABYDOGE": "jpg",
  "2Z": "png",
  "4STOCK": "webp",
  "9BIT": "png",
  "A8": "png",
  "AALON": "png",
  "AAOI": "png",
  "AAOIB": "png",
  "AAOION": "png",
  "AAPL": "png",
  "AAPLB": "png",
  "AAPLON": "png",
  "AAPLX": "png",
  "AAVE": "png",
  "AB": "png",
  "ABBC": "png",
  "ABBV": "png",
  "ABEL": "png",
  "ABEY": "png",
  "ABNBON": "png",
  "ACE": "png",
  "ACH": "png",
  "ACHRON": "png",
  "ACM": "png",
  "ACN": "png",
  "ACNON": "png",
  "ACS": "jpg",
  "ACT": "jpg",
  "ACU": "png",
  "ADA": "png",
  "ADBE": "png",
  "ADBEB": "webp",
  "ADBEON": "png",
  "ADI": "png",
  "ADION": "png",
  "ADX": "png",
  "AEDZ": "png",
  "AEHR": "png",
  "AEHRON": "png",
  "AEON": "png",
  "AERO": "png",
  "AEVO": "png",
  "AFC": "png",
  "AGENCY": "png",
  "AGI": "png",
  "AGLD": "jpg",
  "AGON": "png",
  "AGPUB": "webp",
  "AGRO": "png",
  "AGRS": "png",
  "AGT": "jpg",
  "AI": "png",
  "AIA": "png",
  "AIC": "png",
  "AIDOGE": "jpg",
  "AIINU": "png",
  "AIN": "jpg",
  "AIO": "jpg",
  "AIOT": "jpg",
  "AIOZ": "png",
  "AIPO": "png",
  "AIX": "png",
  "AIXBT": "png",
  "AIXDROP": "png",
  "AKE": "png",
  "AKITA": "jpg",
  "AKT": "png",
  "ALAB": "png",
  "ALABB": "png",
  "ALABON": "png",
  "ALCH": "png",
  "ALE": "png",
  "ALEO": "png",
  "ALEPH": "png",
  "ALEX": "png",
  "ALGO": "png",
  "ALI": "webp",
  "ALICE": "jpg",
  "ALIGN": "png",
  "ALL": "png",
  "ALLO": "png",
  "ALPH": "png",
  "ALPINE": "png",
  "ALT": "png",
  "ALU": "png",
  "AMAT": "png",
  "AMATB": "png",
  "AMATON": "png",
  "AMC": "jpg",
  "AMCB": "webp",
  "AMD": "png",
  "AMDB": "png",
  "AMDON": "png",
  "AME": "png",
  "AMGNON": "png",
  "AMI": "png",
  "AMKRON": "png",
  "AMORE": "jpg",
  "AMP": "png",
  "AMZN": "png",
  "AMZNB": "png",
  "AMZNON": "png",
  "AMZNX": "png",
  "ANET": "png",
  "ANETON": "png",
  "ANIME": "jpg",
  "ANKR": "png",
  "ANON": "png",
  "ANSEM": "jpg",
  "ANTHROPIC": "png",
  "ANVL": "png",
  "ANYONE": "png",
  "AO": "png",
  "APE": "png",
  "APEPE": "png",
  "APEX": "png",
  "API3": "png",
  "APLD": "png",
  "APLDON": "png",
  "APP": "png",
  "APR": "jpg",
  "APT": "png",
  "APTM": "png",
  "AR": "jpg",
  "ARB": "jpg",
  "ARC": "jpg",
  "AREA": "png",
  "ARG": "png",
  "ARGUS": "png",
  "ARIA": "png",
  "ARK": "png",
  "ARKK": "png",
  "ARKM": "png",
  "ARM": "png",
  "ARMB": "png",
  "ARMON": "png",
  "ARPA": "jpg",
  "ARRR": "png",
  "ARS": "png",
  "ARX": "png",
  "ASE": "png",
  "ASM": "png",
  "ASML": "png",
  "ASMLB": "png",
  "ASMLON": "png",
  "ASR": "png",
  "ASS": "jpg",
  "ASSET": "png",
  "ASTER": "png",
  "ASTR": "png",
  "ASTS": "png",
  "ASTSB": "png",
  "ASTSON": "png",
  "AT": "png",
  "ATH": "png",
  "ATLAS": "png",
  "ATM": "png",
  "ATOM": "png",
  "ATR": "png",
  "ATS": "png",
  "AUCTION": "jpg",
  "AUDIO": "png",
  "AUKI": "png",
  "AURORA": "jpg",
  "AVA": "png",
  "AVAIL": "png",
  "AVAX": "png",
  "AVGO": "png",
  "AVGOB": "png",
  "AVGOON": "png",
  "AVL": "png",
  "AVNT": "png",
  "AWE": "jpg",
  "AXIS": "jpg",
  "AXL": "jpg",
  "AXM": "png",
  "AXP": "png",
  "AXPON": "png",
  "AXS": "png",
  "AXTI": "png",
  "AXTIB": "png",
  "AXTION": "png",
  "AZERO": "png",
  "AZTEC": "png",
  "B2": "jpg",
  "B3": "png",
  "B3TR": "png",
  "BA": "png",
  "BABA": "png",
  "BABAB": "png",
  "BABAON": "png",
  "BABY": "png",
  "BABYDOGE": "jpg",
  "BAC": "png",
  "BACON": "png",
  "BAN": "jpg",
  "BANANA": "png",
  "BANANAS31": "png",
  "BAND": "png",
  "BANK": "jpg",
  "BAON": "png",
  "BAR": "png",
  "BARD": "png",
  "BAS": "jpg",
  "BASECAT": "jpg",
  "BASED": "png",
  "BAT": "png",
  "BATON": "png",
  "BAX": "png",
  "BAY": "png",
  "BB": "png",
  "BBB": "png",
  "BBSOL": "png",
  "BCAT": "jpg",
  "BCH": "png",
  "BDCA": "png",
  "BDX": "png",
  "BE": "png",
  "BEAM": "png",
  "BEAT": "png",
  "BEB": "png",
  "BEL": "png",
  "BELLS": "jpg",
  "BELUGA": "png",
  "BEM": "jpg",
  "BEN": "jpg",
  "BEON": "png",
  "BERA": "png",
  "BERT": "png",
  "BFUSD": "png",
  "BGB": "png",
  "BICO": "jpg",
  "BID": "jpg",
  "BIDUON": "png",
  "BIGTIME": "jpg",
  "BILL": "png",
  "BIO": "jpg",
  "BIOFI": "png",
  "BIRB": "jpg",
  "BITO": "png",
  "BKN": "png",
  "BLEND": "webp",
  "BLESS": "png",
  "BLKON": "png",
  "BLUAI": "png",
  "BLUE": "png",
  "BLUECHIP": "jpg",
  "BLUR": "png",
  "BMNR": "png",
  "BMNRB": "png",
  "BMNRON": "png",
  "BMT": "png",
  "BNB": "png",
  "BNC": "png",
  "BNCB": "png",
  "BNKR": "png",
  "BNSOL": "png",
  "BNT": "png",
  "BOB": "png",
  "BOBA": "png",
  "BOBER": "png",
  "BOBO": "png",
  "BOME": "png",
  "BONE": "png",
  "BONER": "jpg",
  "BONK": "jpg",
  "BORDR": "png",
  "BOSON": "png",
  "BOT": "jpg",
  "BOTB": "png",
  "BP": "png",
  "BR": "png",
  "BRETT": "png",
  "BREV": "png",
  "BREW": "png",
  "BRISE": "png",
  "BRKBB": "webp",
  "BRN": "png",
  "BROCCOLI": "jpg",
  "BSB": "jpg",
  "BSP": "png",
  "BST": "jpg",
  "BSV": "png",
  "BTC": "png",
  "BTCBAM": "png",
  "BTCMT": "png",
  "BTR": "png",
  "BTS": "png",
  "BTSLR": "jpg",
  "BTT": "png",
  "BTW": "png",
  "BTY": "png",
  "BULLA": "png",
  "BXE": "jpg",
  "BXN": "png",
  "BYD": "png",
  "BZR": "png",
  "BZZ": "png",
  "C98": "png",
  "CA": "jpg",
  "CAKE": "png",
  "CAP": "jpg",
  "CARDS": "png",
  "CARV": "png",
  "CASHCAT": "jpg",
  "CAT": "jpg",
  "CATE": "png",
  "CATI": "png",
  "CATON": "webp",
  "CAW": "png",
  "CBRS": "png",
  "CBRSB": "png",
  "CBRSON": "png",
  "CC": "png",
  "CCD": "jpg",
  "CEEK": "png",
  "CEG": "png",
  "CEGON": "webp",
  "CELL": "png",
  "CELO": "jpg",
  "CELR": "png",
  "CENT": "jpg",
  "CES": "png",
  "CETUS": "png",
  "CFG": "jpg",
  "CFX": "png",
  "CGN": "png",
  "CGPT": "png",
  "CHECK": "png",
  "CHEEMS": "jpg",
  "CHEQ": "png",
  "CHEX": "png",
  "CHILLGUY": "png",
  "CHIP": "png",
  "CHIRP": "png",
  "CHOMP": "png",
  "CHR": "png",
  "CHZ": "png",
  "CIEN": "png",
  "CIENON": "png",
  "CIFR": "png",
  "CITY": "png",
  "CKB": "png",
  "CKBTC": "png",
  "CKUSDT": "png",
  "CLANKER": "png",
  "CLAUDIA": "png",
  "CLAUS": "png",
  "CLO": "png",
  "CLONE": "png",
  "CLORE": "png",
  "CLOUD": "png",
  "CLSK": "png",
  "CMC20": "png",
  "CMGON": "png",
  "CNPY": "png",
  "COAI": "png",
  "COCA": "png",
  "COCO": "png",
  "COHR": "png",
  "COHRB": "png",
  "COHRON": "png",
  "COIN": "png",
  "COINB": "png",
  "COINDEPO": "png",
  "COINON": "png",
  "COINX": "png",
  "COLLECT": "png",
  "COMP": "png",
  "COOK": "png",
  "COOKIE": "png",
  "COOL": "jpg",
  "COP": "jpg",
  "COPON": "png",
  "COPPER": "png",
  "COPXON": "png",
  "COQ": "png",
  "CORE": "jpg",
  "CORN": "jpg",
  "CORZ": "png",
  "CORZON": "png",
  "COST": "png",
  "COSTON": "png",
  "COTI": "png",
  "COW": "png",
  "CP": "jpg",
  "CPH": "png",
  "CPNGON": "png",
  "CPOOL": "jpg",
  "CRCL": "png",
  "CRCLB": "png",
  "CRCLON": "png",
  "CRCLX": "png",
  "CRDO": "png",
  "CRDOB": "png",
  "CRDOON": "png",
  "CREO": "png",
  "CREPE": "png",
  "CRETA": "png",
  "CRM": "png",
  "CRMB": "png",
  "CRMON": "png",
  "CRO": "png",
  "CROC": "jpg",
  "CRV": "png",
  "CRWD": "png",
  "CRWDB": "png",
  "CRWV": "png",
  "CRWVB": "png",
  "CRWVON": "png",
  "CRYPGPT": "jpg",
  "CSCO": "png",
  "CSCOON": "png",
  "CSPR": "png",
  "CT": "png",
  "CTC": "png",
  "CTK": "jpg",
  "CTM": "png",
  "CTR": "png",
  "CTSI": "png",
  "CTX": "png",
  "CVC": "png",
  "CVNA": "png",
  "CVX": "png",
  "CVXON": "png",
  "CYBER": "png",
  "CYBRO": "png",
  "CYPH": "png",
  "CYPHB": "webp",
  "CYS": "png",
  "DADDY": "png",
  "DAG": "png",
  "DAO": "webp",
  "DARK": "jpg",
  "DASH": "png",
  "DATA": "png",
  "DBR": "png",
  "DCR": "png",
  "DCT": "png",
  "DDMT": "png",
  "DDOG": "png",
  "DEEP": "png",
  "DEFI": "png",
  "DEGEN": "png",
  "DELL": "png",
  "DELLB": "png",
  "DELLON": "png",
  "DELTA": "jpg",
  "DEOD": "png",
  "DEP": "png",
  "DESU": "png",
  "DEUS": "png",
  "DEXE": "png",
  "DGAI": "png",
  "DGB": "png",
  "DGMA": "png",
  "DIA": "png",
  "DIAM": "jpg",
  "DIN": "jpg",
  "DINGO": "png",
  "DIONE": "png",
  "DIS": "png",
  "DISON": "png",
  "DJI6930": "jpg",
  "DJT": "png",
  "DJTB": "png",
  "DKNG": "png",
  "DMTR": "jpg",
  "DNA": "png",
  "DNX": "png",
  "DODO": "png",
  "DOG": "png",
  "DOGE": "png",
  "DOGS": "png",
  "DOLO": "png",
  "DOOD": "png",
  "DOPE": "png",
  "DOS": "png",
  "DOT": "jpg",
  "DRAM": "jpg",
  "DRAMB": "png",
  "DRAMON": "png",
  "DRB": "jpg",
  "DRG": "png",
  "DRIFT": "png",
  "DRV": "png",
  "DSYNC": "png",
  "DTEC": "png",
  "DUSK": "png",
  "DUST": "png",
  "DVO": "png",
  "DYDX": "png",
  "DYM": "png",
  "EDEL": "png",
  "EDEN": "png",
  "EDGE": "jpg",
  "EDU": "png",
  "EFC": "png",
  "EGLD": "png",
  "EGO": "png",
  "EIGEN": "jpg",
  "EL": "png",
  "ELF": "png",
  "ELON": "jpg",
  "ELSA": "png",
  "EMBER": "png",
  "EMBLEM": "jpg",
  "ENA": "png",
  "ENF": "png",
  "ENJ": "png",
  "ENPHON": "png",
  "ENS": "jpg",
  "ENSO": "jpg",
  "EPIC": "png",
  "EQIXON": "png",
  "ERA": "png",
  "ERG": "jpg",
  "ESE": "jpg",
  "ESP": "jpg",
  "ESPORTS": "png",
  "ETC": "png",
  "ETH": "png",
  "ETHFI": "jpg",
  "ETHW": "png",
  "ETN": "png",
  "ETNON": "png",
  "EUL": "png",
  "EURI": "jpg",
  "EV": "png",
  "EVA": "png",
  "EVAA": "png",
  "EVT": "png",
  "EWT": "png",
  "EWY": "png",
  "EWYB": "png",
  "EWYON": "png",
  "FACT": "png",
  "FAR": "jpg",
  "FARTBOY": "png",
  "FARTCOIN": "jpg",
  "FATCOIN": "jpg",
  "FB": "png",
  "FCELON": "png",
  "FCXON": "png",
  "FDUSD": "png",
  "FEG": "jpg",
  "FET": "png",
  "FF": "png",
  "FHE": "jpg",
  "FIDA": "png",
  "FIGHT": "png",
  "FIL": "png",
  "FIRO": "png",
  "FIT": "png",
  "FLEX": "png",
  "FLNC": "png",
  "FLNCB": "png",
  "FLOCK": "png",
  "FLOKI": "png",
  "FLORK": "jpg",
  "FLOW": "png",
  "FLR": "png",
  "FLT": "png",
  "FLUID": "png",
  "FLUX": "png",
  "FLY": "jpg",
  "FLYBRAIN": "png",
  "FNON": "png",
  "FOGO": "png",
  "FOLD": "jpg",
  "FOLKS": "png",
  "FONE": "jpg",
  "FOREST": "png",
  "FORM": "jpg",
  "FORT": "png",
  "FORU": "png",
  "FOXSY": "jpg",
  "FRAX": "png",
  "FRC": "png",
  "FRONG": "png",
  "FRTS": "png",
  "FTT": "png",
  "FUEL": "png",
  "FUSD": "png",
  "FUSE": "png",
  "FUTU": "png",
  "FUTUON": "png",
  "FWDI": "png",
  "FWDIB": "png",
  "FWOG": "png",
  "GAG": "jpg",
  "GAIB": "png",
  "GAIN": "png",
  "GALA": "png",
  "GAME": "png",
  "GANG": "jpg",
  "GAS": "png",
  "GBCK": "png",
  "GCOIN": "jpg",
  "GDX": "png",
  "GE": "png",
  "GENIUS": "png",
  "GEOD": "png",
  "GEON": "png",
  "GEV": "png",
  "GEVON": "png",
  "GF": "png",
  "GFSON": "png",
  "GGBR": "png",
  "GHUB": "png",
  "GHX": "png",
  "GIGA": "png",
  "GIGGLE": "jpg",
  "GLDON": "png",
  "GLM": "png",
  "GLMR": "png",
  "GLQ": "png",
  "GLW": "png",
  "GLWB": "png",
  "GLWON": "png",
  "GM": "jpg",
  "GME": "png",
  "GMEB": "png",
  "GMEE": "png",
  "GMEON": "png",
  "GMT": "png",
  "GMX": "png",
  "GNO": "png",
  "GOAT": "jpg",
  "GOATED": "jpg",
  "GODE": "jpg",
  "GOHOME": "png",
  "GOMINING": "webp",
  "GOOGL": "png",
  "GOOGLB": "png",
  "GOOGLON": "png",
  "GOOGLX": "png",
  "GP": "jpg",
  "GPRO": "png",
  "GPROB": "png",
  "GPS": "png",
  "GRAM": "png",
  "GRASS": "jpg",
  "GRIFFAIN": "jpg",
  "GROK": "png",
  "GROVE": "png",
  "GRT": "png",
  "GRVT": "jpg",
  "GS": "png",
  "GSB": "png",
  "GSTOCK": "png",
  "GTAI": "jpg",
  "GTC": "png",
  "GUA": "png",
  "GUN": "jpg",
  "GWEI": "png",
  "HAEDAL": "jpg",
  "HAI": "png",
  "HANA": "jpg",
  "HANDL": "png",
  "HANDY": "png",
  "HARRY": "jpg",
  "HBAR": "png",
  "HD": "png",
  "HDN": "png",
  "HEI": "png",
  "HELI": "jpg",
  "HELLO": "jpg",
  "HEMI": "png",
  "HFT": "png",
  "HGPT": "png",
  "HIGGS": "jpg",
  "HIMS": "png",
  "HIMSB": "png",
  "HIMSON": "png",
  "HINT": "png",
  "HIVE": "png",
  "HMM": "jpg",
  "HMND": "jpg",
  "HMSTR": "png",
  "HNS": "png",
  "HNT": "png",
  "HOLO": "png",
  "HOME": "png",
  "HOOD": "png",
  "HOODB": "png",
  "HOODON": "png",
  "HOODX": "png",
  "HOOKED": "jpg",
  "HOOKR": "jpg",
  "HORIZON": "png",
  "HOT": "png",
  "HP": "png",
  "HPE": "png",
  "HPEB": "webp",
  "HSK": "jpg",
  "HTR": "png",
  "HTX": "png",
  "HUMA": "png",
  "HUT": "png",
  "HVLO": "png",
  "HYPE": "jpg",
  "HYPER": "png",
  "IAUON": "png",
  "IBIT": "png",
  "IBKR": "png",
  "IBM": "png",
  "IBMB": "png",
  "IBMON": "png",
  "IBVM": "jpg",
  "ICNT": "png",
  "ICP": "png",
  "ID": "png",
  "IDOL": "jpg",
  "IEFAON": "png",
  "ILV": "png",
  "IMO": "png",
  "IMX": "png",
  "IN": "jpg",
  "INDEX": "jpg",
  "INFQ": "png",
  "INIT": "png",
  "INJ": "png",
  "INTC": "png",
  "INTCB": "png",
  "INTCON": "png",
  "INTER": "png",
  "INTU": "png",
  "INTUON": "png",
  "INTWB": "png",
  "INX": "png",
  "IO": "png",
  "ION": "png",
  "IONQ": "png",
  "IONQON": "png",
  "IOST": "png",
  "IOTA": "png",
  "IOTX": "png",
  "IQ": "png",
  "IREN": "png",
  "IRENB": "png",
  "IRENON": "png",
  "IRON": "jpg",
  "IRYS": "png",
  "ISRGON": "png",
  "IWM": "png",
  "IXS": "png",
  "JASMY": "jpg",
  "JCT": "png",
  "JD": "png",
  "JDON": "png",
  "JEANPHIL": "jpg",
  "JELLYJELLY": "webp",
  "JETTON": "jpg",
  "JGGL": "png",
  "JIMOTHY": "png",
  "JMDT": "png",
  "JNJ": "png",
  "JOE": "png",
  "JPM": "png",
  "JPMB": "png",
  "JPMON": "png",
  "JST": "jpg",
  "JTO": "png",
  "JUGGERNAUT": "jpg",
  "JUP": "png",
  "JUV": "png",
  "KAG": "png",
  "KAIA": "png",
  "KAIO": "png",
  "KAITO": "jpg",
  "KAS": "png",
  "KASPY": "png",
  "KAT": "png",
  "KATA": "png",
  "KAVA": "png",
  "KCS": "png",
  "KDX": "png",
  "KEELON": "png",
  "KEKIUS": "jpg",
  "KERNEL": "png",
  "KGEN": "png",
  "KGST": "png",
  "KII": "jpg",
  "KIMCHI": "png",
  "KISHU": "png",
  "KITE": "png",
  "KITEAI": "png",
  "KLAC": "png",
  "KLV": "jpg",
  "KMNO": "png",
  "KNC": "jpg",
  "KO": "png",
  "KOM": "webp",
  "KOMA": "jpg",
  "KORU": "jpg",
  "KORUB": "png",
  "KSKD": "png",
  "KSM": "jpg",
  "KSTRB": "png",
  "KTA": "jpg",
  "KUB": "png",
  "KULA": "png",
  "KZEN": "png",
  "L3": "png",
  "LA": "png",
  "LAB": "png",
  "LADYS": "png",
  "LAUNCH": "png",
  "LAVA": "png",
  "LAYER": "png",
  "LAZIO": "png",
  "LDO": "png",
  "LEE": "png",
  "LIGHT": "png",
  "LIME": "png",
  "LINEA": "png",
  "LINGO": "png",
  "LINK": "png",
  "LISTA": "png",
  "LIT": "png",
  "LITE": "png",
  "LITEB": "png",
  "LITEON": "png",
  "LLY": "png",
  "LLYB": "png",
  "LLYON": "png",
  "LMT": "png",
  "LMWR": "png",
  "LNQ": "png",
  "LOFI": "png",
  "LOT": "jpg",
  "LPT": "png",
  "LQR": "png",
  "LQTY": "png",
  "LRC": "png",
  "LRCX": "png",
  "LRCXON": "png",
  "LSK": "png",
  "LTC": "png",
  "LTT": "png",
  "LUCKY": "png",
  "LULU": "png",
  "LUMIA": "jpg",
  "LUNA": "png",
  "LUNC": "png",
  "LUNRON": "png",
  "LYN": "png",
  "LYX": "png",
  "M87": "png",
  "MA": "jpg",
  "MAGIC": "png",
  "MAGMA": "png",
  "MAGS": "png",
  "MAJOR": "jpg",
  "MANA": "png",
  "MANTA": "jpg",
  "MANTRA": "png",
  "MANYU": "jpg",
  "MAON": "png",
  "MAPO": "png",
  "MARA": "png",
  "MARAON": "png",
  "MARSCOIN": "png",
  "MAS": "png",
  "MASK": "jpg",
  "MAT": "jpg",
  "MAV": "png",
  "MAVIA": "jpg",
  "MBG": "png",
  "MBL": "png",
  "MBX": "png",
  "MCAT": "jpg",
  "MCD": "png",
  "MCDON": "png",
  "MCDX": "png",
  "MCN": "jpg",
  "MCRT": "png",
  "MDB": "png",
  "MDBB": "png",
  "MDT": "png",
  "ME": "png",
  "MEE": "png",
  "MEGA": "jpg",
  "MELANIA": "png",
  "MELI": "png",
  "MEME": "png",
  "MENGO": "png",
  "MERL": "jpg",
  "MET": "png",
  "META": "png",
  "METAB": "png",
  "METAL": "png",
  "METAON": "png",
  "METAX": "png",
  "METH": "png",
  "METIS": "png",
  "MEW": "png",
  "MEY": "png",
  "MGO": "jpg",
  "MHA": "png",
  "MICRODUCK": "png",
  "MILLI": "png",
  "MIN": "png",
  "MINA": "png",
  "MINIMA": "png",
  "MIRA": "png",
  "MITO": "png",
  "MIU": "png",
  "ML": "png",
  "MLC": "png",
  "MMT": "png",
  "MNSRY": "png",
  "MNT": "png",
  "MOCA": "jpg",
  "MOCHI": "png",
  "MOEW": "jpg",
  "MOG": "png",
  "MON": "png",
  "MOO": "jpg",
  "MOODENG": "jpg",
  "MORPHO": "png",
  "MOVE": "png",
  "MOVR": "png",
  "MP": "png",
  "MPC": "jpg",
  "MPLX": "png",
  "MPON": "png",
  "MRK": "png",
  "MRNA": "png",
  "MRNAB": "png",
  "MRNAON": "png",
  "MRVL": "png",
  "MRVLB": "png",
  "MRVLON": "png",
  "MSFT": "png",
  "MSFTB": "png",
  "MSFTON": "png",
  "MSTR": "png",
  "MSTRB": "png",
  "MSTRON": "png",
  "MSTU": "png",
  "MTL": "png",
  "MTO": "png",
  "MU": "png",
  "MUB": "png",
  "MUBARAK": "jpg",
  "MUON": "png",
  "MUSEBOOK": "png",
  "MUUB": "png",
  "MVLLB": "png",
  "MVRK": "png",
  "MWXT": "png",
  "MX": "jpg",
  "MXL": "png",
  "MXLON": "png",
  "MXNA": "png",
  "MXSOL": "png",
  "MYRO": "jpg",
  "MYST": "png",
  "MYX": "jpg",
  "NAKA": "jpg",
  "NAORIS": "jpg",
  "NAP": "png",
  "NATG": "png",
  "NATIX": "png",
  "NAVX": "png",
  "NBIS": "png",
  "NBISB": "png",
  "NBISON": "png",
  "NEAR": "jpg",
  "NEIRO": "jpg",
  "NEO": "png",
  "NERO": "jpg",
  "NES": "png",
  "NET": "jpg",
  "NETON": "png",
  "NETX": "png",
  "NEWT": "jpg",
  "NEX": "jpg",
  "NEXA": "png",
  "NEXO": "png",
  "NFLX": "png",
  "NFLXB": "png",
  "NFLXON": "png",
  "NFT": "png",
  "NIGHT": "png",
  "NIL": "jpg",
  "NKE": "png",
  "NKEON": "png",
  "NLS": "png",
  "NMR": "png",
  "NOCK": "jpg",
  "NODE": "png",
  "NOKB": "png",
  "NOKON": "png",
  "NOM": "jpg",
  "NOS": "jpg",
  "NOT": "jpg",
  "NOW": "png",
  "NOWON": "png",
  "NPC": "png",
  "NRG": "png",
  "NS": "png",
  "NST": "png",
  "NTH": "jpg",
  "NTX": "png",
  "NUM": "png",
  "NVDA": "png",
  "NVDAB": "png",
  "NVDAON": "png",
  "NVDAX": "png",
  "NVO": "png",
  "NVOON": "png",
  "NXPC": "png",
  "NXT": "png",
  "NYM": "png",
  "OBI": "png",
  "OBT": "jpg",
  "OCTA": "png",
  "OFC": "jpg",
  "OFT": "png",
  "OG": "png",
  "OGN": "jpg",
  "OGY": "png",
  "OHO": "png",
  "OKB": "png",
  "OKLO": "png",
  "OKLOON": "png",
  "OLAS": "png",
  "OMG": "jpg",
  "OMI": "png",
  "ON": "png",
  "ONDO": "png",
  "ONDSON": "png",
  "ONE": "png",
  "ONG": "png",
  "ONT": "png",
  "OORT": "png",
  "OP": "png",
  "OPEN": "png",
  "OPENAI": "png",
  "OPG": "png",
  "OPN": "jpg",
  "OPTIMUS": "png",
  "ORAI": "png",
  "ORBIO": "jpg",
  "ORCA": "png",
  "ORCL": "png",
  "ORCLB": "png",
  "ORCLON": "png",
  "ORDER": "png",
  "ORDI": "png",
  "ORTA": "png",
  "OSMO": "png",
  "OTK": "png",
  "OURA": "png",
  "OUST": "png",
  "OVR": "png",
  "OWL": "jpg",
  "OXT": "png",
  "OZO": "jpg",
  "P2P": "png",
  "PAAL": "png",
  "PAID": "jpg",
  "PAIR": "png",
  "PAL": "png",
  "PANW": "png",
  "PANWON": "png",
  "PART": "png",
  "PARTI": "png",
  "PATH": "png",
  "PAXG": "png",
  "PAYAI": "png",
  "PBR": "jpg",
  "PBRON": "png",
  "PDD": "png",
  "PDDB": "png",
  "PDDON": "png",
  "PEAQ": "png",
  "PENDLE": "png",
  "PENG": "png",
  "PENGB": "png",
  "PENGU": "png",
  "PEOPLE": "jpg",
  "PEP": "png",
  "PEPE": "jpg",
  "PEPECOIN": "png",
  "PEPPER": "png",
  "PG": "png",
  "PGPT": "jpg",
  "PHA": "png",
  "PHNIX": "jpg",
  "PI": "jpg",
  "PIB": "jpg",
  "PIEVERSE": "png",
  "PIG": "jpg",
  "PIN": "png",
  "PIPPIN": "png",
  "PIT": "png",
  "PIVX": "png",
  "PIXEL": "png",
  "PLAI": "png",
  "PLAY": "jpg",
  "PLEARN": "png",
  "PLN": "png",
  "PLON": "png",
  "PLTR": "png",
  "PLTRB": "png",
  "PLTRON": "png",
  "PLUGON": "png",
  "PLUME": "png",
  "PMG": "png",
  "PMT": "jpg",
  "PNG": "png",
  "PNIC": "jpg",
  "PNUT": "png",
  "POD": "jpg",
  "POET": "png",
  "POKT": "jpg",
  "POL": "png",
  "POLS": "png",
  "POLYX": "png",
  "POND": "png",
  "PONKE": "png",
  "PONS": "jpg",
  "POPCAT": "jpg",
  "POR": "png",
  "PORTAL": "jpg",
  "PORTO": "jpg",
  "POWER": "png",
  "POWR": "png",
  "PPC": "png",
  "PRCL": "png",
  "PRIME": "png",
  "PRIORS": "jpg",
  "PRL": "png",
  "PRO": "png",
  "PROM": "png",
  "PROMPT": "jpg",
  "PROPC": "png",
  "PROPS": "png",
  "PROS": "jpg",
  "PROVE": "png",
  "PRSM": "jpg",
  "PSG": "png",
  "PTB": "png",
  "PUBLIC": "jpg",
  "PUFFER": "png",
  "PUMP": "jpg",
  "PUMPBTC": "png",
  "PUNDIX": "jpg",
  "PURR": "png",
  "PUSS": "jpg",
  "PVT": "png",
  "PX": "png",
  "PXP": "png",
  "PYBOBO": "png",
  "PYPL": "png",
  "PYPLB": "png",
  "PYPLON": "png",
  "PYR": "png",
  "PYTH": "png",
  "PYUSD": "png",
  "QBTSON": "png",
  "QBX": "png",
  "QCOM": "png",
  "QCOMB": "png",
  "QCOMON": "png",
  "QI": "jpg",
  "QIE": "jpg",
  "QKC": "jpg",
  "QNT": "jpg",
  "QNTB": "png",
  "QONE": "jpg",
  "QOR": "png",
  "QORPO": "png",
  "QQQ": "png",
  "QQQB": "png",
  "QQQON": "png",
  "QRL": "png",
  "QTUM": "png",
  "QUAI": "png",
  "QUBIC": "png",
  "QUICK": "png",
  "QUID": "jpg",
  "RACA": "jpg",
  "RAD": "png",
  "RAIL": "jpg",
  "RAIN": "png",
  "RAM": "png",
  "RARE": "png",
  "RATS": "png",
  "RAVE": "jpg",
  "RAY": "jpg",
  "RBNT": "jpg",
  "RBT": "png",
  "RC": "png",
  "RDDT": "png",
  "RDDTB": "png",
  "RDDTON": "png",
  "RDW": "png",
  "RDWON": "png",
  "RE": "png",
  "READY": "png",
  "RECALL": "png",
  "RED": "png",
  "REDO": "png",
  "REEF": "png",
  "REGNON": "png",
  "REM": "png",
  "RENDER": "png",
  "REQ": "png",
  "RESOLV": "png",
  "REZ": "png",
  "RGTION": "png",
  "RH": "png",
  "RHEA": "png",
  "RICE": "png",
  "RIF": "png",
  "RIO": "png",
  "RIOT": "png",
  "RIOTON": "png",
  "RITUAL": "jpg",
  "RIVER": "png",
  "RIVN": "png",
  "RIVNON": "png",
  "RIZE": "png",
  "RKLB": "png",
  "RKLBB": "png",
  "RKLBON": "png",
  "RLC": "png",
  "RLS": "png",
  "RLUSD": "png",
  "RNBW": "png",
  "ROAM": "jpg",
  "ROBIN": "jpg",
  "ROBO": "jpg",
  "ROG": "png",
  "ROLL": "png",
  "RON": "jpg",
  "RONIN": "jpg",
  "ROSE": "png",
  "RPL": "png",
  "RSC": "png",
  "RSR": "png",
  "RT": "jpg",
  "RUJI": "png",
  "RUM": "png",
  "RUNE": "png",
  "RVF": "png",
  "RVN": "png",
  "RWA": "jpg",
  "RWS": "jpg",
  "RWUSD": "webp",
  "RYO": "png",
  "SAFE": "png",
  "SAGA": "jpg",
  "SAHARA": "png",
  "SAI": "png",
  "SAND": "jpg",
  "SANTOS": "png",
  "SAPIEN": "png",
  "SATS": "png",
  "SAUBER": "png",
  "SAUCE": "png",
  "SBETON": "png",
  "SBTC": "png",
  "SC": "png",
  "SCARCITY": "png",
  "SCCP": "png",
  "SCR": "jpg",
  "SD": "png",
  "SDR": "png",
  "SECZ": "png",
  "SECZB": "png",
  "SEDA": "png",
  "SEI": "png",
  "SENSO": "png",
  "SENT": "png",
  "SERV": "png",
  "SFP": "png",
  "SGB": "png",
  "SHARE": "jpg",
  "SHAZB": "png",
  "SHELL": "jpg",
  "SHIB": "png",
  "SHIDO": "png",
  "SHM": "jpg",
  "SHOP": "png",
  "SHOPON": "png",
  "SHR": "png",
  "SHROOM": "jpg",
  "SHX": "png",
  "SI": "png",
  "SIGN": "jpg",
  "SINGULARRY": "png",
  "SIREN": "png",
  "SIS": "png",
  "SIX": "png",
  "SKHY": "png",
  "SKHYB": "png",
  "SKHYON": "png",
  "SKL": "png",
  "SKR": "jpg",
  "SKY": "jpg",
  "SKYAI": "png",
  "SLC": "png",
  "SLP": "png",
  "SLVON": "png",
  "SLX": "png",
  "SMARS": "png",
  "SMART": "jpg",
  "SMCI": "png",
  "SMCIB": "png",
  "SMCION": "png",
  "SMH": "png",
  "SMHB": "png",
  "SN51": "png",
  "SN64": "jpg",
  "SN75": "png",
  "SNDK": "png",
  "SNDKB": "png",
  "SNDKON": "png",
  "SNEK": "png",
  "SNOW": "png",
  "SNOWON": "png",
  "SNPS": "png",
  "SNPT": "jpg",
  "SNSY": "png",
  "SNT": "png",
  "SNX": "png",
  "SNXX": "png",
  "SNXXB": "png",
  "SOEX": "png",
  "SOFI": "png",
  "SOFION": "webp",
  "SOIL": "png",
  "SOL": "png",
  "SOLV": "jpg",
  "SOLVEX": "png",
  "SOMI": "png",
  "SONIC": "png",
  "SONY": "png",
  "SOON": "png",
  "SOPH": "png",
  "SOSO": "jpg",
  "SOUNON": "png",
  "SOXL": "png",
  "SOXLB": "png",
  "SOXLON": "png",
  "SOXS": "png",
  "SOXSB": "png",
  "SOXSON": "png",
  "SOXX": "png",
  "SOXXON": "png",
  "SPA": "png",
  "SPACE": "png",
  "SPCM": "jpg",
  "SPCX": "png",
  "SPCXB": "png",
  "SPCXON": "png",
  "SPCXX": "png",
  "SPELL": "png",
  "SPK": "png",
  "SPLD": "png",
  "SPOT": "jpg",
  "SPOTON": "png",
  "SPX": "png",
  "SPY": "png",
  "SPYB": "png",
  "SPYON": "png",
  "SPYX": "png",
  "SQD": "png",
  "SQQQ": "png",
  "SQQQB": "png",
  "SRDS": "png",
  "SRX": "png",
  "SSV": "png",
  "STABLE": "png",
  "STAMP": "jpg",
  "STANDARD": "png",
  "STAR": "jpg",
  "STBL": "png",
  "STEEM": "png",
  "STETH": "png",
  "STO": "png",
  "STOC": "jpg",
  "STONK": "png",
  "STONKBROKER": "jpg",
  "STONKEX": "png",
  "STONKS": "jpg",
  "STOP": "png",
  "STORJ": "png",
  "STORM": "jpg",
  "STRAX": "png",
  "STRC": "png",
  "STRCON": "png",
  "STREAM": "png",
  "STRK": "png",
  "STX": "png",
  "STXB": "png",
  "STXON": "png",
  "SUE": "jpg",
  "SUI": "png",
  "SUN": "png",
  "SUPER": "png",
  "SUPRA": "jpg",
  "SUSHI": "png",
  "SVL": "jpg",
  "SVN": "png",
  "SWARM": "jpg",
  "SWARMS": "jpg",
  "SWCH": "jpg",
  "SWELL": "webp",
  "SXT": "jpg",
  "SYL": "png",
  "SYMM": "png",
  "SYN": "png",
  "SYRUP": "png",
  "SYS": "png",
  "TA": "jpg",
  "TAC": "jpg",
  "TAG": "png",
  "TAI": "png",
  "TAIKO": "png",
  "TAKE": "png",
  "TAO": "jpg",
  "TAP": "jpg",
  "TARA": "png",
  "TATSU": "png",
  "TBC": "png",
  "TBK": "png",
  "TCOM": "png",
  "TEAM": "png",
  "TEL": "png",
  "TEM": "png",
  "TENDIES": "png",
  "TER": "png",
  "TET": "png",
  "TFUEL": "png",
  "THE": "png",
  "THETA": "png",
  "TIA": "jpg",
  "TIBBIR": "png",
  "TICS": "png",
  "TKO": "png",
  "TLF": "png",
  "TLM": "jpg",
  "TLOS": "png",
  "TLT": "png",
  "TMF": "png",
  "TMFB": "png",
  "TMX": "png",
  "TNK": "png",
  "TNSR": "png",
  "TOKEN": "png",
  "TOLLY": "webp",
  "TONNY": "png",
  "TOP": "png",
  "TORCH": "jpg",
  "TORN": "jpg",
  "TOSHI": "png",
  "TOWER": "png",
  "TOWNS": "png",
  "TPTU": "png",
  "TQQQ": "png",
  "TQQQB": "png",
  "TQQQON": "png",
  "TRAC": "jpg",
  "TRADE": "png",
  "TRADOOR": "png",
  "TRB": "png",
  "TREAD": "png",
  "TREE": "png",
  "TRIA": "png",
  "TRUMP": "png",
  "TRUST": "png",
  "TRUTH": "png",
  "TRX": "png",
  "TSEM": "png",
  "TSLA": "png",
  "TSLAB": "png",
  "TSLAON": "png",
  "TSLAX": "png",
  "TSLL": "png",
  "TSM": "png",
  "TSMB": "png",
  "TSMON": "png",
  "TST": "png",
  "TTMION": "png",
  "TTN": "png",
  "TTWO": "png",
  "TUP": "jpg",
  "TURBO": "png",
  "TURTLE": "png",
  "TUSD": "png",
  "TUT": "png",
  "TWT": "png",
  "TX": "png",
  "TXNON": "png",
  "UAI": "png",
  "UB": "png",
  "UBER": "png",
  "UBERON": "png",
  "UBIK": "webp",
  "UCN": "png",
  "UDAO": "jpg",
  "UDS": "jpg",
  "ULTIMA": "png",
  "UMA": "png",
  "UMC": "png",
  "UMXM": "png",
  "UNGON": "png",
  "UNH": "png",
  "UNI": "png",
  "UNP": "png",
  "UP": "png",
  "UPC": "png",
  "UQC": "png",
  "URAON": "png",
  "US": "png",
  "USAD": "png",
  "USAR": "png",
  "USARB": "png",
  "USARON": "png",
  "USAT": "png",
  "USD": "png",
  "USD1": "png",
  "USDC": "png",
  "USDD": "jpg",
  "USDE": "png",
  "USDEB": "png",
  "USDF": "png",
  "USDGO": "png",
  "USDP": "png",
  "USDS": "webp",
  "USDT": "png",
  "USDTB": "jpg",
  "USDY": "png",
  "USELESS": "png",
  "USTC": "png",
  "USUAL": "jpg",
  "UVXYB": "png",
  "VANA": "png",
  "VELO": "png",
  "VELVET": "jpg",
  "VEREM": "jpg",
  "VERONA": "jpg",
  "VERT": "png",
  "VET": "png",
  "VEX": "png",
  "VINE": "jpg",
  "VINU": "png",
  "VIRTUAL": "png",
  "VISTA": "jpg",
  "VOOI": "png",
  "VOW": "png",
  "VPR": "png",
  "VR": "png",
  "VRA": "png",
  "VRT": "png",
  "VRTON": "png",
  "VSN": "png",
  "VST": "png",
  "VSTB": "webp",
  "VSTON": "png",
  "VSYS": "png",
  "VTHO": "png",
  "VVV": "png",
  "WAL": "png",
  "WARD": "png",
  "WATT": "png",
  "WAVES": "png",
  "WAXL": "png",
  "WAXP": "png",
  "WBETH": "png",
  "WBT": "png",
  "WBTC": "png",
  "WCT": "png",
  "WDC": "png",
  "WDCB": "png",
  "WDCON": "png",
  "WEETH": "png",
  "WELF": "png",
  "WEMIX": "png",
  "WEN": "jpg",
  "WENB": "png",
  "WET": "jpg",
  "WFI": "png",
  "WHITEWHALE": "jpg",
  "WHUF": "png",
  "WIF": "jpg",
  "WILD": "png",
  "WIN": "png",
  "WKC": "png",
  "WLD": "jpg",
  "WLFI": "png",
  "WMT": "png",
  "WMTON": "png",
  "WMTX": "png",
  "WOD": "png",
  "WOJAK": "jpg",
  "WOO": "png",
  "WXT": "jpg",
  "XAI": "png",
  "XAN": "png",
  "XAU": "jpg",
  "XAUT": "png",
  "XAVA": "png",
  "XCH": "png",
  "XCN": "jpg",
  "XCX": "jpg",
  "XDB": "jpg",
  "XDC": "png",
  "XDP": "png",
  "XEC": "png",
  "XEF": "png",
  "XEL": "png",
  "XEN": "jpg",
  "XEP": "png",
  "XFI": "png",
  "XGZ": "png",
  "XL1": "png",
  "XLK": "png",
  "XLM": "jpg",
  "XMN": "png",
  "XMR": "png",
  "XNA": "png",
  "XNO": "png",
  "XNT": "jpg",
  "XNY": "png",
  "XOM": "png",
  "XOMON": "png",
  "XP": "png",
  "XPD": "png",
  "XPIN": "png",
  "XPL": "png",
  "XPR": "jpg",
  "XPT": "jpg",
  "XPX": "png",
  "XRB": "png",
  "XRD": "png",
  "XRP": "png",
  "XRPC": "jpg",
  "XSWAP": "png",
  "XTER": "jpg",
  "XTM": "png",
  "XTZ": "png",
  "XU3O8": "png",
  "XUSD": "png",
  "XVG": "jpg",
  "XVS": "jpg",
  "XX": "jpg",
  "XYO": "png",
  "YB": "png",
  "YFI": "jpg",
  "YGG": "png",
  "YOM": "png",
  "ZAMA": "png",
  "ZANO": "png",
  "ZBCN": "jpg",
  "ZBT": "png",
  "ZCAT": "webp",
  "ZEC": "png",
  "ZEN": "png",
  "ZENT": "png",
  "ZEPH": "png",
  "ZEREBRO": "png",
  "ZEST": "jpg",
  "ZETA": "png",
  "ZETRIX": "png",
  "ZIG": "png",
  "ZIL": "png",
  "ZK": "png",
  "ZKC": "png",
  "ZKJ": "png",
  "ZKP": "png",
  "ZM": "png",
  "ZMB": "webp",
  "ZOOM": "png",
  "ZORA": "jpg",
  "ZRO": "jpg",
  "ZRX": "png",
  "ZS": "png",
  "ZTC": "png",
  "ZYLO": "png",
  "ZZZ": "png",
};
